import { FieldValidator } from "./validation.types.ts";

export const composeValidators =
  (validators: FieldValidator[]): FieldValidator =>
  (val, parent, root) =>
    validators.reduce(
      (error, validator) => error || validator(val, parent, root),
      undefined
    );
